import { useInfiniteQuery } from 'react-query';
import { getPlansList } from '../../../../../api/services/mediaPlanning/plansList';
import { useError } from '../../common/Errors/ErrorContext/ErrorContext';

const useMediaPlansInfinite = (searchTerm: string | null, limit = '10') => {
  const { showError } = useError();

  const { data, fetchNextPage, isFetchingNextPage, isLoading } =
    useInfiniteQuery(
      ['get-media-plans', searchTerm],
      ({ pageParam = undefined }) => getPlansList(searchTerm, pageParam, limit),
      {
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.message || error.message || 'Unknown error';
          showError(errorMessage);
        },
        getNextPageParam: (lastPage) => lastPage?.data?.next || null, // Stops when 'next' is null
      }
    );

  const plans =
    data?.pages.flatMap((page) => page?.data?.mediaPlans ?? []) || [];

  const total = data?.pages?.[0]?.data?.total || 0;

  const lastPage = data?.pages?.[data.pages.length - 1];
  const hasNextPage = !!lastPage?.data?.next;

  return {
    plans,
    total,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  };
};

export default useMediaPlansInfinite;
